<template>
  <v-card
    :flat="isFlat"
    class="py-3 mt-3"
  >
    <form-group title="Dados do OCR">
      <v-row>
        <v-col cols="6">
          <span class="h2Header secondary300">Dados da frente do documento:</span>
          <ocr-data-view
            v-model="payload.dataByOcrFront"
            :loading="isLoading"
            :compare="compareUserData"
            autofill="Não identificado"
            class="mt-3"
          />
        </v-col>
        <v-col cols="6">
          <span class="h2Header secondary300">Dados do verso do documento:</span>
          <ocr-data-view
            v-model="payload.dataByOcrBack"
            :loading="isLoading"
            :compare="compareUserData"
            autofill="Não identificado"
            class="mt-3"
          />
        </v-col>
      </v-row>
    </form-group>
  </v-card>
</template>

<script>
import AnalysisCardMixin from 'Modules/contacard/analysisTable/components/cards/AnalysisCardMixin';
import OcrDataView from 'Modules/contacard/analysisTable/components/dataViews/OcrDataView.vue';

export default {
  name: 'ClientDataOcrInfoCard',
  components: { OcrDataView },
  mixins: [AnalysisCardMixin],
};
</script>
